import { render } from "./RequestAbout.vue?vue&type=template&id=f4142168&scoped=true&ts=true"
import script from "./RequestAbout.vue?vue&type=script&lang=ts"
export * from "./RequestAbout.vue?vue&type=script&lang=ts"

import "./RequestAbout.vue?vue&type=style&index=0&id=f4142168&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4142168"]])

export default __exports__